import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontRightShockAbsorberProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function FrontRightShockAbsorber(props: FrontRightShockAbsorberProps) {
  return (
    <svg
      width="70"
      height="30"
      viewBox="0 0 70 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 124, left: 247}}
      onClick={props.onClick}
    >
      <path
        d="M35.0002 5C38.2719 5 41.1768 6.57104 43.0012 9H63.0002C66.3139 9 69.0002 11.6863 69.0002 15C69.0002 18.3137 66.3139 21 63.0002 21H43.0012C41.1768 23.429 38.2719 25 35.0002 25C31.7285 25 28.8236 23.429 26.9992 21H7.00018C3.68647 21 1.00018 18.3137 1.00018 15C1.00018 11.6863 3.68647 9 7.00018 9H26.9992C28.8236 6.57104 31.7285 5 35.0002 5Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <circle
        cx="35.0002"
        cy="15"
        r="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="63.0002"
        cy="15"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <circle
        cx="7.00018"
        cy="15"
        r="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M27.0002 9H7.00018C3.68647 9 1.00018 11.6863 1.00018 15C1.00018 18.3137 3.68647 21 7.00018 21H27.0002"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M43.0002 9L63.0002 9C66.3139 9 69.0002 11.6863 69.0002 15C69.0002 18.3137 66.3139 21 63.0002 21H43.0002"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="35.0002"
        cy="15"
        r="10"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M22 9.16916C24.3086 4.33925 29.2619 1 35 1C40.7381 1 45.6914 4.33925 48 9.16916M22 21.4229C23.734 25.0507 26.9601 27.8375 30.8901 29M48 21.4229C46.266 25.0507 43.0399 27.8375 39.1099 29"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
